module.exports = __webpack_public_path__ + "static/img/computer-md.018d5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/computer-md.png
// module id = 5awd
// module chunks = 0